import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: ''
})

export class RootComponent {
}
